import React from 'react';
import { Link } from 'react-router-dom';

const NAV_LINKS = [
  { href: '/about', label: 'About' },
  { href: '/support', label: 'Support' },
  { href: '/tos', label: 'Terms of Service' },
  { href: '/privacy', label: 'Privacy Policy' },
  { href: '/faq', label: 'FAQ' },
  { href: '/gear', label: 'Gear' },
  { href: '/contact', label: 'Contact' }
];

/**
 * Footer component for the site
 */
const Footer = () => {
  const footerRef = React.useRef(null);
  React.useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    const currentFooter = footerRef.current;
    if (!currentFooter) {
      return;
    }

    const footers = Array.from(document.querySelectorAll('footer'));
    footers.forEach((node) => {
      if (node === currentFooter) {
        return;
      }
      const parent = node.parentNode;
      if (parent) {
        parent.removeChild(node);
      }
    });
  }, []);

  return (
    <footer ref={footerRef} className="site-footer bg-light text-center text-lg-start mt-5" data-react-footer="true">
      <div className="container p-4">
        <div className="row">
          <div className="col-lg-6 col-md-12 mb-4 mb-md-0 text-start text-lg-start">
            <h5 className="text-uppercase">ASMR.guru</h5>
            <p>Whisper the future.</p>
          </div>
          <div className="col-lg-3 col-md-6 mb-4 mb-md-0">
            <h5 className="text-uppercase">Links</h5>
            <ul className="list-unstyled mb-0 footer-nav">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-dark">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-3 col-md-6 mb-4 mb-md-0">
            <h5 className="text-uppercase">Connect</h5>
            <ul className="list-unstyled">
              <li>
                <a href="https://www.youtube.com/@Asmr-dot-guru" className="text-dark">
                  <i className="fab fa-youtube me-2"></i>YouTube
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="text-center p-3 footer-legal">
        &copy; 2025 ASMR.guru - All Rights Reserved
      </div>
    </footer>
  );
};

export default Footer;

